import { render, staticRenderFns } from "./ProjectCurrentAlarms.vue?vue&type=template&id=1cb235a6&"
import script from "./ProjectCurrentAlarms.vue?vue&type=script&lang=js&"
export * from "./ProjectCurrentAlarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports